import { IUseLoyalty } from './types';

export const useLoyalty = () => ({} as IUseLoyalty);
